export const GET = {
  REQUEST: 'MealPlanner/GET/Request',
  SUCCESS: 'MealPlanner/GET/Success',
  FAILURE: 'MealPlanner/GET/Failure'
};
export const FOR_SUBMIT = {
  REQUEST: 'MealPlanner/FOR_SUBMIT/Request',
  SUCCESS: 'MealPlanner/FOR_SUBMIT/Success',
  FAILURE: 'MealPlanner/FOR_SUBMIT/Failure'
};
export const CLEAR = {
  SUCCESS: 'MealPlanner/CLEAR/Success'
};
export const UPDATE = {
  REQUEST: 'MealPlanner/UPDATE/Request',
  SUCCESS: 'MealPlanner/UPDATE/Success',
  FAILURE: 'MealPlanner/UPDATE/Failure'
};
export const UPDATE_KITCHEN_FOR_SUBMIT = {
  REQUEST: 'MealPlanner/UPDATE_KITCHEN_FOR_SUBMIT/Request',
  SUCCESS: 'MealPlanner/UPDATE_KITCHEN_FOR_SUBMIT/Success',
  FAILURE: 'MealPlanner/UPDATE_KITCHEN_FOR_SUBMIT/Failure'
};
export const UPDATE_KITCHEN = {
  REQUEST: 'MealPlanner/UPDATE_KITCHEN/Request',
  SUCCESS: 'MealPlanner/UPDATE_KITCHEN/Success',
  FAILURE: 'MealPlanner/UPDATE_KITCHEN/Failure'
};
export const EXPORT_MEAL_PLANS = {
  REQUEST: 'MealPlanner/ExportMealPlans/Request',
  SUCCESS: 'MealPlanner/ExportMealPlans/Success',
  FAILURE: 'MealPlanner/ExportMealPlans/Failure'
};
export const QUERY_MEAL_PLANNER_LOCATIONS = {
  REQUEST: 'Locations/QueryMealPlannerLocations/Request',
  SUCCESS: 'Locations/QueryMealPlannerLocations/Success',
  FAILURE: 'Locations/QueryMealPlannerLocations/Failure'
};
